import { Component, OnInit, Input, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-survey-completed-dialog',
  templateUrl: './survey-completed-dialog.component.html',
  styleUrls: ['./survey-completed-dialog.component.scss'],
  standalone: false
})
export class SurveyCompletedDialogComponent implements OnInit, OnDestroy {
  @Input() dialogObj: any
  constructor() { }

  ngOnInit(): void {
  }
  ngOnDestroy(): void {
  }
}
